module.exports = __webpack_public_path__ + "img/office5.99ffc11c.jpg";